import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { BasicButton } from '../../widgets/components/UI/BasicButton'
import { ToolTipUI } from '../../widgets/components/UI/ToolTipUI'
import { Formik } from 'formik'
import { Form } from 'react-bootstrap'
import { industryOptions } from '../../../core/_constants'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth'
import { removeNullFields } from '../../../core/_util'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import * as Yup from 'yup'
import { SelectInput } from '../../widgets/components/Input/SelectInput'
import { referralSources, teamSizeOptions } from '../../profile/core/_constants'

const PersonalBusinessOTP = () => {
  const { formatMessage } = useIntl()
  const [selectedOption2, setSelectedOption2] = useState<string>('business')
  const [selectedOption, setSelectedOption] = useState<boolean>(false)
  const navigate = useNavigate()
  const { currentUser, companyId } = useAuth()
  const isRecordskeeper = process.env.REACT_APP_BRAND === 'RK'

  const initialValues = {
    industry: selectedOption2 === 'business' ? '' : 'Other',
    teamSize: selectedOption2 === 'business' ? '' : '0',
    heardAboutUs: '',
  }

  const manageRecordsSchema = Yup.object().shape({
    industry: Yup.string().when([], {
      is: () => selectedOption2 === 'business',
      then: (schema) => schema.required(formatMessage({ id: 'Industry is required' })),
      otherwise: (schema) => schema.notRequired(),
    }),
    teamSize: Yup.string().when([], {
      is: () => selectedOption2 === 'business',
      then: (schema) => schema.required(formatMessage({ id: 'Team size is required' })),
      otherwise: (schema) => schema.notRequired(),
    }),
    heardAboutUs: Yup.string().required(formatMessage({ id: 'Heard about is required' })),
  })

  // useEffect(() => {
  //   const handleWindowLoad = () => {
  //     TagManager.dataLayer({
  //       dataLayer: {
  //         event: GTMEvent.UsagePlanScreenShown,
  //         action: 'normal',
  //         metadata: removeNullFields({
  //           user_id: currentUser?.userId,
  //           user_hash: currentUser?.user_hash,
  //           email: currentUser?.email,
  //           company: {
  //             companyId: currentUser?.companyId,
  //           },
  //         }),
  //       },
  //     })
  //   }
  //   window.onload = handleWindowLoad
  //   return () => {
  //     window.onload = null
  //   }
  // }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // const handleSubmit = (values:any) => {
  //   localStorage.setItem('usecase', selectedOption)
  //   navigate('/auth/verify-phone')
  //   TagManager.dataLayer({
  //     dataLayer: {
  //       event: GTMEvent.UsagePlanSelectionSuccessful,
  //       action: 'normal',
  //       metadata: removeNullFields({
  //         user_id: currentUser?.userId,
  //         user_hash: currentUser?.user_hash,
  //         company: {
  //           company_id: companyId,
  //           usage_type: selectedOption,
  //         },
  //       }),
  //     },
  //   })

  const handleSubmit = (values: any) => {
    const teamSize = selectedOption2 === 'business' ? values.teamSize : '0'
    const industry = selectedOption2 === 'business' ? values.industry : 'Other'
    const forClientUse = selectedOption2 === 'business' ? `${selectedOption}` : 'false'
    localStorage.setItem('usecase', selectedOption2)
    localStorage.setItem('forClientUse', forClientUse)
    localStorage.setItem('teamSize', teamSize)
    localStorage.setItem('industry', industry)
    localStorage.setItem('heardAboutUs', values.heardAboutUs)
    if (
      (!currentUser?.contact && isRecordskeeper) ||
      (!currentUser?.contactVerifiedAt && isRecordskeeper) ||
      (!currentUser?.countryDialingCode && isRecordskeeper)
    ) {
      navigate('/auth/verify-phone')
    } else if (isRecordskeeper) {
      navigate('/onboarding/')
    }
    TagManager.dataLayer({
      dataLayer: {
        event: GTMEvent.CompanyUsageInfoSuccessful,
        metadata: removeNullFields({
          user_id: currentUser?.userId,
          user_hash: currentUser?.user_hash,
          heard_about_us: values.heardAboutUs,
          company: {
            company_id: companyId,
            usage_type: selectedOption2,
            for_client_usage: selectedOption,
            industry: values.industry,
            team_size: !isNaN(Number(teamSize)) ? Number(teamSize) : undefined,
          },
        }),
      },
    })
  }

  return (
    <div>
      <div className=''>
        <div className='d-flex flex-column justify-content-center align-items-center otp-screen py-6 px-md-0 px-2 gap-6 w-100'>
          <img
            src={toAbsoluteUrl(`/media/auth/industry-details.svg`)}
            width='200'
            height='150'
            alt='one-more-step'
            className='mt-6'
          />
          <div className='d-flex flex-column align-items-center justify-content-center gap-6 col-md-12 col-12'>
            <div>
              <h1 className='mb-0 text-center font-size-20'>
                {formatMessage({
                  id: `Help Us Set Up Your AI-Powered Record Keeping Environment `,
                })}
              </h1>
            </div>
            <div>
              <p className='mb-0 text-center'>
                {formatMessage({
                  id: `Based on your choice, we’ll set up a world-class, AI-powered record structure tailored just for you—so you can stay organized effortlessly from day one!`,
                })}
              </p>
            </div>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={manageRecordsSchema}
            enableReinitialize={true}
            onSubmit={handleSubmit}
            validateOnMount
          >
            {(formik) => (
              <Form className='d-flex flex-column align-items-center gap-4 w-100 mb-6'>
                <div className='col-md-12 col-12 d-flex flex-column gap-8'>
                  <div className='d-flex flex-column gap-4'>
                    <label className='d-flex'>
                      <p className='mb-0'>
                        {formatMessage({
                          id: 'How do you plan to revolutionize your record-keeping?',
                        })}
                        <ToolTipUI tooltipText='Based on your choice, we’ll set up a world-class, AI-powered record structure tailored just for you—so you can stay organized effortlessly from day one!' />
                      </p>
                    </label>
                    <div
                      className='d-flex gap-4 align-items-center'
                      onClick={() => setSelectedOption2('personal')}
                    >
                      <input
                        type='radio'
                        className='form-check-input'
                        checked={selectedOption2 === 'personal'}
                        onChange={() => setSelectedOption2('personal')}
                      />{' '}
                      <div className='d-flex'>
                        <p className='m-0'>
                          {formatMessage({
                            id: `Personal & Family’s Record Keeping`,
                          })}
                          <ToolTipUI tooltipText='Select this option if you are managing records for yourself, your kids, and your family—all in one secure place.' />
                        </p>
                      </div>
                    </div>
                    <div
                      className='d-flex gap-4 align-items-center'
                      onClick={() => setSelectedOption2('business')}
                    >
                      <input
                        type='radio'
                        className='form-check-input'
                        checked={selectedOption2 === 'business'}
                        onChange={() => setSelectedOption2('business')}
                      />{' '}
                      <div className='d-flex'>
                        <p className='m-0'>
                          {formatMessage({
                            id: `Business & Enterprise Record Keeping`,
                          })}
                          <ToolTipUI
                            tooltipText={`Select this option if you are streamlining record-keeping for business with automated organization and compliance support.`}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                  {selectedOption2 === 'business' && (
                    <>
                      <div className='d-flex flex-column gap-4'>
                        <label className='d-flex'>
                          <p className='mb-0'>
                            {formatMessage({
                              id: 'Are you signing up for yourself or for your client',
                            })}
                            <ToolTipUI tooltipText='Would you like to use RecordsKeeper.AI for managing your own records, or are you setting it up for a client? This will help tailor the experience and recommendations specifically to your needs.' />
                          </p>
                        </label>
                        <div
                          className='d-flex gap-4 align-items-center'
                          onClick={() => setSelectedOption(false)}
                        >
                          <input
                            type='radio'
                            className='form-check-input'
                            checked={!selectedOption}
                            onChange={() => setSelectedOption(false)}
                          />{' '}
                          <div className='d-flex'>
                            <p className='m-0'>
                              {formatMessage({
                                id: `I will use it for myself or my own business`,
                              })}
                              <ToolTipUI tooltipText='Select this option if you are using RecordsKeeper.AI for your own company or personal family records.' />
                            </p>
                          </div>
                        </div>
                        <div
                          className='d-flex gap-4 align-items-center'
                          onClick={() => setSelectedOption(true)}
                        >
                          <input
                            type='radio'
                            className='form-check-input'
                            checked={selectedOption}
                            onChange={() => setSelectedOption(true)}
                          />{' '}
                          <div className='d-flex'>
                            <p className='m-0'>
                              {formatMessage({
                                id: `I will use it on behalf of my clients or customers`,
                              })}
                              <ToolTipUI
                                tooltipText={`Select this option if you are using RecordsKeeper.AI for your client' s company or their business needs.`}
                              />
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className='d-flex flex-column'>
                        <SelectInput
                          label={formatMessage({ id: 'What industry do you operate in?' })}
                          fieldName={'industry'}
                          placeholder={formatMessage({ id: 'Select Industry' })}
                          formik={formik}
                          toolTipText={formatMessage({
                            id: `Your industry determines specific compliance requirements and record management needs. Selecting accurately ensures we can provide relevant templates and automation workflows designed for your sector's regulations.`,
                          })}
                          options={industryOptions}
                          isStarRequired={true}
                          onBlur={formik.handleBlur}
                        />
                        <SelectInput
                          label={formatMessage({ id: 'How many people work at your company?' })}
                          fieldName='teamSize'
                          placeholder={formatMessage({ id: 'Select Team Size' })}
                          formik={formik}
                          toolTipText={formatMessage({
                            id: `Team size helps us recommend the right collaboration features and access controls. This information ensures your RecordsKeeper.AI environment scales appropriately with your organization.`,
                          })}
                          options={teamSizeOptions}
                          isStarRequired={true}
                          onBlur={formik.handleBlur}
                        />
                        <SelectInput
                          label={formatMessage({ id: 'Where did you hear About us' })}
                          fieldName='heardAboutUs'
                          placeholder={formatMessage({ id: 'Select' })}
                          formik={formik}
                          toolTipText={formatMessage({
                            id: `Your response helps us understand which of our outreach efforts are most effective, allowing us to continue providing valuable information through channels that matter to professionals like you.`,
                          })}
                          options={referralSources}
                          isStarRequired={true}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                    </>
                  )}
                </div>
                <BasicButton
                  buttonText={formatMessage({ id: 'Submit' })}
                  height='44px'
                  customClass='bg-primary text-white w-100'
                  // padding='12px 24px'
                  disabled={!formik.isValid}
                  onClick={() => handleSubmit(formik.values)}
                />
              </Form>
            )}
          </Formik>
        </div>
        {/* </div> */}
      </div>
    </div>
  )
}

export default PersonalBusinessOTP
